type StatusBadgeProps = {
  status: string;
  size?: "sm" | "md";
};

const statusStyles: Record<string, string> = {
  Nuevo: "bg-secondary-500/15 text-secondary-700",
  Contactado: "bg-primary-500/15 text-primary-700",
  "Respondió": "bg-accent-500/15 text-accent-700",
  "Presentación": "bg-primary-500/10 text-primary-700",
  Webinar: "bg-secondary-500/15 text-secondary-700",
  Seguimiento: "bg-amber-100 text-amber-700",
  Interesado: "bg-accent-500/15 text-accent-700",
  Socio: "bg-primary-500 text-background-950",
  "Conversión": "bg-primary-500 text-background-950",
  "No interesado": "bg-background-200 text-foreground-600",
};

export default function StatusBadge({ status, size = "sm" }: StatusBadgeProps) {
  const cls = statusStyles[status] ?? "bg-background-200 text-foreground-700";
  const pad = size === "md" ? "px-3 py-1 text-xs" : "px-2.5 py-0.5 text-[11px]";
  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full whitespace-nowrap ${pad} ${cls}`}>
      {status}
    </span>
  );
}

export const statusDotStyles: Record<string, string> = {
  Nuevo: "bg-secondary-500",
  Contactado: "bg-primary-500",
  "Respondió": "bg-accent-500",
  "Presentación": "bg-primary-400",
  Webinar: "bg-secondary-400",
  Seguimiento: "bg-amber-400",
  Interesado: "bg-accent-400",
  Socio: "bg-primary-600",
  "Conversión": "bg-primary-600",
  "No interesado": "bg-background-400",
};